import { Navigate } from 'react-router-dom'
import { ROUTES } from '@/config/routes'

const AcessRoute = ({ children }: { children: JSX.Element }) => {
  const domain = window.location.hostname

  if (domain.includes('localhost')) {
    return children
  }

  // se o domínio começar com "web." → redireciona para "/signin"
  if (domain.startsWith('web.')) {
    return <Navigate to={ROUTES.SIGNIN.path} replace />
  }

  return children
}

export default AcessRoute
